const vendorUCR = (() => {

    let vendorID;
    let UCREntries;
    let ucrPopup;
    let serviceDropdownData;   
    let serviceLocationDropdownData;
    let CDBData;
    let defaultOption = {text:'',value:''};
    let oTable;
    let isReadOnly = false;

    async function init(vendorId) {
        vendorID = vendorId;
        UCREntries = await authorizationsAjax.getVenderUCREntriesAsync(vendorID);       
        
        const serviceData = await authorizationsAjax.getUCRServices();
        serviceDropdownData = JSON.parse(serviceData.getUCRServicesResult).map(service => ({
            text: service.Description,
            value: service.service_id,
            attributes: [{ key: 'data-fixedrate', value: service.fixed_rate }, { key: 'data-billbylocation', value: service.bill_by_location },
            { key: 'data-billbyratio', value: service.bill_by_ratio }, { key: 'data-includeinfundinglimit', value: service.include_in_funding_limit }]
        }));  
        serviceDropdownData.unshift(defaultOption);
        const serviceLocations = await authorizationsAjax.getUCRServiceLocations();
        serviceLocationDropdownData = JSON.parse(serviceLocations.getUCRServiceLocationsResult);
        serviceLocationDropdownData.unshift(defaultOption);
        CDBData = [1, 2, 3, 4, 5, 6, 7, 8].map(num => ({
            text: String(num),
            value: num
        }));
        CDBData.unshift(defaultOption);
    }

    function getMarkup() {
        const vendorUCRWrap = document.createElement('div');
        vendorUCRWrap.classList.add('planSummary');

        const importantTables = buildNewVendorUCRForm();
        vendorUCRWrap.appendChild(importantTables);

        return vendorUCRWrap;
    }

    function buildNewVendorUCRForm() {
        const vendorUCRDiv = document.createElement('div');
        vendorUCRDiv.classList.add('additionalQuestionWrap');

        const tableOptions = {
            plain: false,
            tableId: 'vendorInfoUCRTable',
            columnHeadings: ['Service ', 'Group Size', 'Service Location', 'CDB Category', 'Assessment/ Acuity Score', 'Start Date', 'End Date', 'UCR'],
            endIcon: false,
            callback: function (event) {
                if (event.target.childNodes[0].innerText == undefined) return;
                const UCREntry = UCREntries.getVenderUCREntriesResult.find(entry=> entry.id === parseInt(event.target.dataset.id));               
                showUCRPopup(UCREntry);
            },
        };

        oTable = table.build(tableOptions);

        const headers = oTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'string'); // Service
        headers[1].setAttribute('data-type', 'string'); // Group Size
        headers[2].setAttribute('data-type', 'string'); // Service Location 
        headers[3].setAttribute('data-type', 'string'); // CDB Category 
        headers[4].setAttribute('data-type', 'string'); //  Assessment/ Acuity Score
        headers[5].setAttribute('data-type', 'date'); // Start Date
        headers[6].setAttribute('data-type', 'date'); // End Date 
        headers[7].setAttribute('data-type', 'amount'); //  UCR


        const column1 = document.createElement('div')
        column1.classList.add('col-1')
        const addNewCard = document.createElement("div");
        addNewCard.classList.add("card");
        const addNewCardBody = document.createElement("div");
        addNewCardBody.classList.add("card__body");
        addNewCard.innerHTML = `<div class="card__header">UCR</div>`;
        addNewCard.appendChild(addNewCardBody)
        column1.appendChild(addNewCard)

        addNewCardBody.appendChild(oTable);
        vendorUCRDiv.appendChild(column1);

        // Call function to allow table sorting by clicking on a header.
        table.sortTableByHeader(oTable); 
        populateTable();

        return vendorUCRDiv;
    }
   
    function populateTable() {       
        for (let i = 0; i < UCREntries.getVenderUCREntriesResult?.length; i++) {
            UCREntries.getVenderUCREntriesResult[i]['id'] = i + 1;
        }        
        let tableData = UCREntries.getVenderUCREntriesResult.map((entry) => ({
            attributes: [{ key: 'data-id', value: entry.id}],
            values: [entry.service, entry.groupSize, entry.serviceLocation, entry.CDBCategory, entry.assessmentAcuityScore, entry.startDate == '' ? '' : moment(entry.startDate).format('MM/DD/YYYY'), entry.endDate == '' ? '' : moment(entry.endDate).format('MM/DD/YYYY'), entry.UCR == '' ? entry.UCR : '$' + entry.UCR],
        }));
        table.populate(oTable, tableData);
    }
    function showUCRPopup(data) {       
        let service = data?.serviceId || null;
        let groupSize = data?.groupSize || null;
        let serviceLocation = data?.serviceLocationId || null;
        let CDBCategory = data?.CDBCategory || null;
        let assessmentAcuityScore = data?.assessmentRange || null;
        let startDate = (data?.startDate||'')!==''? moment(data?.startDate).format('YYYY-MM-DD') :null;
        let endDate = (data?.endDate||'') !==''? moment(data?.endDate).format('YYYY-MM-DD') :null;
        let UCR = data?.UCR || null;
        let saveOrUpdate = data ? 'update' : 'save';
        if (saveOrUpdate === 'save') {
            startDate = moment().format('YYYY-MM-DD');
        }

        if (!data) {
            if ($.session.authorizationInsertVendorInfo) isReadOnly = false;
            else if (!$.session.authorizationInsertVendorInfo) isReadOnly = true;
        }
        else if (data) {
            if ($.session.authorizationsVendorInfoUpdate) isReadOnly = false;
            else if (!$.session.authorizationsVendorInfoUpdate) isReadOnly = true;
        }

        ucrPopup = POPUP.build({
            header: data ? 'Edit UCR' : 'Add New UCR',
            id: 'ucrPopup',
        });

        const serviceDropdown = dropdown.build({
            id: 'serviceDropdown',
            label: 'Service',
            dropdownId: 'serviceDropdown', 
            readonly: isReadOnly
        });
        const groupSizeInput = input.build({
            id: 'groupSizeInput',
            label: 'Group Size',          
            value: groupSize,
            readonly: isReadOnly
        });
        const serviceLocationDropdown = dropdown.build({
            id: 'serviceLocationDropdown',
            label: 'Service Location',
            dropdownId: 'serviceLocationDropdown', 
            readonly: isReadOnly
        });       
        const CDBDropdown = dropdown.build({
            id: 'CDBDropdown',
            label: 'CDB',
            dropdownId: 'CDBDropdown',  
            readonly: isReadOnly
        });        
        const assessmentDropdown = dropdown.build({
            id: 'assessmentDropdown',
            label: 'Assessment/Acuity',
            dropdownId: 'assessmentDropdown',  
            readonly: isReadOnly
        });        
        const startDateInput = input.build({
            label: 'Start Date',
            type: 'date',
            style: 'secondary',
            value: startDate,
            readonly: isReadOnly
        });
        const endDateInput = input.build({
            label: 'End Date',
            type: 'date',
            style: 'secondary',
            value: endDate,
            readonly: isReadOnly
        });
        const ucrInput = input.build({
            id: 'ucrInput',
            label: 'UCR',
            value: UCR,
            readonly: isReadOnly
        });
      
        const saveBtn = button.build({
            id: 'ucrPopupSave',
            text: data ? 'Apply' : 'Save',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                const result = await authorizationsAjax.saveUCR({
                    vendorId: vendorID,
                    serviceId: service,
                    serviceIdOld: data?.serviceId || null,
                    startDate: startDate,
                    startDateOld: data?.startDate || startDate,
                    endDate: endDate,
                    endDateOld: data?.endDate || endDate,
                    groupSize: groupSize || 0.00,
                    cdbCategory: CDBCategory || 0,
                    serviceLocation: serviceLocation || '',
                    assessmentRange: assessmentAcuityScore || 0,
                    rate: UCR || 0,
                    saveorUpdate: saveOrUpdate,
                });
                const saveResult = result.saveUCRResult;
                if (saveResult === 'success') {
                    POPUP.hide(ucrPopup);
                    successfulSave.show(data ? 'Updated' : 'Saved');
                    setTimeout(function () {
                        successfulSave.hide();
                    }, 2000);

                    UCREntries = await authorizationsAjax.getVenderUCREntriesAsync(vendorID);
                    populateTable();
                }
                else if (saveResult === 'exists') {
                    POPUP.hide(ucrPopup);
                    showAlreadyExistsWarning();
                }
            },
        });       
        const cancelBtn = button.build({
            id: 'ucrPopupCancel',
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(ucrPopup);
            },
        });   

        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        if (!isReadOnly) {
            btnWrap.appendChild(saveBtn);
        }
        btnWrap.appendChild(cancelBtn);

        const dateWrap = document.createElement('div');
        dateWrap.style.display = 'grid';
        dateWrap.style.gridTemplateColumns = '1fr 1fr';
        dateWrap.style.gap = '10px';
        dateWrap.style.marginBottom = '10px';
        dateWrap.style.width = '100%';
        dateWrap.appendChild(startDateInput);
        dateWrap.appendChild(endDateInput);      
        const errorMsg = document.createElement('p');
        errorMsg.style.display = 'none';
        errorMsg.style.marginBottom = '15px';
        errorMsg.style.marginTop = '-15px';
        errorMsg.style.color = 'red';
        errorMsg.textContent = 'Start Date cannot be greater than the End Date';

        //populate dropdowns
        dropdown.populate(CDBDropdown, CDBData, CDBCategory);       
        dropdown.populate(serviceDropdown, serviceDropdownData, service);
        dropdown.populate(serviceLocationDropdown, serviceLocationDropdownData, serviceLocation);

        //events
        serviceDropdown.addEventListener('change', function (e) {
            service = e.target.value;
            if (!service || service === '') {
                serviceDropdown.classList.add('error');
            }
            else {
                serviceDropdown.classList.remove('error');
            }
            checkSeriveSelected(e.target);           
        });
        groupSizeInput.addEventListener("input", (e) => {
            let value = e.target.value;
            value = value.replace(/[^0-9]/g, "");
            // Prevent leading zero if needed
            if (value.startsWith("0")) {
                value = value.replace(/^0+/, "");
            }   
            e.target.value = value.substring(0, 4); // Limit to 4 digits
        });
        groupSizeInput.addEventListener('change', (e) => {
            groupSize = e.target.value;
            validatePopupFields();
        });
        serviceLocationDropdown.addEventListener('change', (e) => {
            serviceLocation = e.target.value;
            validatePopupFields();
        });
        CDBDropdown.addEventListener('change', (e) => {
            CDBCategory = e.target.value;
            validatePopupFields();
        });
        assessmentDropdown.addEventListener('change', (e) => {
            assessmentAcuityScore = e.target.value;
            validatePopupFields();
        });
        startDateInput.addEventListener('change', function (e) {
            startDate = e.target.value;
            validatePopupFields();
        });
        endDateInput.addEventListener('change', function (e) {
            endDate = e.target.value === '' ? null : e.target.value;
            validatePopupFields();
        });
        ucrInput.addEventListener("input", (e) => {
            let value = e.target.value;

            // Remove invalid characters
            value = value.replace(/[^0-9.]/g, "");

            // Allow only one decimal point
            const parts = value.split(".");
            if (parts.length > 2) {
                value = parts[0] + "." + parts.slice(1).join("");
            }

            // Limit to 2 decimal places
            if (parts[1]) {
                value = parts[0] + "." + parts[1].slice(0, 2);
            }

            e.target.value = value;   
            UCR = e.target.value;  
            validatePopupFields();
        });
        ucrInput.addEventListener('change', (e) => {
            UCR = e.target.value;     
        });

        ucrPopup.appendChild(serviceDropdown);
        ucrPopup.appendChild(groupSizeInput);
        ucrPopup.appendChild(serviceLocationDropdown);
        ucrPopup.appendChild(CDBDropdown);
        ucrPopup.appendChild(assessmentDropdown);
        ucrPopup.appendChild(dateWrap);
        ucrPopup.appendChild(errorMsg);
        ucrPopup.appendChild(ucrInput);
        ucrPopup.appendChild(btnWrap);
        POPUP.show(ucrPopup);
       
        groupSizeInput.classList.add('disabled');
        serviceLocationDropdown.classList.add('disabled');
        CDBDropdown.classList.add('disabled');
        assessmentDropdown.classList.add('disabled'); 
        if (saveOrUpdate === 'update') {
            const ddl = ucrPopup.querySelector('#serviceDropdown');
            checkSeriveSelected(ddl);
        }
        validatePopupFields();
        function validatePopupFields() {
            serviceDropdown.classList.remove('error');
            groupSizeInput.classList.remove('error');
            serviceLocationDropdown.classList.remove('error');
            CDBDropdown.classList.remove('error');
            assessmentDropdown.classList.remove('error');
            startDateInput.classList.remove('error');
            endDateInput.classList.remove('error');
            ucrInput.classList.remove('error');
            if (!service || service === '') {
                serviceDropdown.classList.add('error');
            }
            if (!groupSizeInput.classList.contains('disabled') && (!groupSize || groupSize === '')) {
                groupSizeInput.classList.add('error');
            }
            if (!serviceLocationDropdown.classList.contains('disabled') && (!serviceLocation || serviceLocation === '')) {
                serviceLocationDropdown.classList.add('error');
            }
            if (!CDBDropdown.classList.contains('disabled') && (!CDBCategory || CDBCategory === '')) {
                CDBDropdown.classList.add('error');
            }
            if (!assessmentDropdown.classList.contains('disabled') && (!assessmentAcuityScore || assessmentAcuityScore === '')) {
                assessmentDropdown.classList.add('error');
            }

            if (!startDate || startDate === '') {
                startDateInput.classList.add('error');
            }
            if (!endDate || endDate === '') {
                endDateInput.classList.add('error');
            }
            if (!UCR || UCR === '') {
                ucrInput.classList.add('error');
            }

            errorMsg.style.display = 'none';
            if ((startDate !== null && endDate !== null) && startDate > endDate) {
                errorMsg.style.display = 'block';
            } 

            
            var ucrPopupDiv = document.getElementById('ucrPopup');
            var hasErrors = [].slice.call(ucrPopupDiv.querySelectorAll('.error:not(button)'));
            if (hasErrors.length === 0) {
                saveBtn.classList.remove('disabled');
                const newData = {
                    vendorId: vendorID,
                    serviceId: service,
                    startDate: moment(startDate).format('YYYY-MM-DD'),
                    endDate: moment(endDate).format('YYYY-MM-DD'),                 
                    groupSize: groupSize || '0.00',
                    cdbCategory: CDBCategory || '0',
                    serviceLocation: serviceLocation || '',
                    assessmentRange: assessmentAcuityScore || '0',
                    rate: UCR || 0,                   
                };
                const oldData = {
                    vendorId: vendorID,
                    serviceId: data?.serviceId || "",
                    startDate: moment(data?.startDate).format('YYYY-MM-DD'),
                    endDate: moment(data?.endDate).format('YYYY-MM-DD'),
                    groupSize: data?.groupSize || '0.00',
                    cdbCategory: data?.CDBCategory || '0',
                    serviceLocation: data?.serviceLocationId || '',
                    assessmentRange: data?.assessmentRange || '0',
                    rate: data?.UCR || 0,           
                };
                
                const isChanged = data && JSON.stringify(oldData) !== JSON.stringify(newData);   
                if (errorMsg.style.display === 'block' || (data && !isChanged)) {
                    saveBtn.classList.add('disabled');
                }
            }
            else {
                saveBtn.classList.add('disabled');
            }
        }
        function resetFields() {
            groupSizeInput.classList.add('disabled');
            groupSizeInput.querySelector('input').value = null;
            groupSize = null;
            CDBDropdown.classList.add('disabled');
            CDBDropdown.querySelector('select').value = '';
            CDBCategory = null;
            serviceLocationDropdown.classList.add('disabled');
            serviceLocationDropdown.querySelector('select').value = '';
            serviceLocation = null;
            assessmentDropdown.classList.add('disabled');
            assessmentDropdown.querySelector('select').value = '';
            assessmentAcuityScore = null;  
        }
        function showAlreadyExistsWarning() {
            var warningPopup = POPUP.build({});
            warningPopup.classList.add('warning');
            var message = document.createElement('p');
            message.innerHTML = 'This UCR overlaps with an existing UCR.';
            message.style.marginBottom = '15px';
            var btnWrap = document.createElement('div');
            btnWrap.classList.add('btnWrap');
            var okBtn = button.build({
                text: 'Ok',
                type: 'contained',
                style: 'secondary',
                callback: () => {
                    POPUP.hide(warningPopup);
                    //const overlay = document.querySelector('.overlay');
                    //overlay.classList.add('visible');
                    POPUP.show(ucrPopup);
                }
            });

            btnWrap.appendChild(okBtn);
            warningPopup.appendChild(message);
            warningPopup.appendChild(btnWrap);
            POPUP.show(warningPopup);
            warningPopup.querySelector('.closePopupBtn').remove();
        }
        function checkSeriveSelected(ddl) {
            if (service && service !== '') {
                const option = ddl.options[ddl.selectedIndex];                  
                if (['C', 'D'].includes(option.dataset.fixedrate)) {
                    groupSizeInput.classList.remove('disabled');
                    if (!groupSize) {
                        groupSizeInput.classList.add('error');
                    }
                    else {
                        groupSizeInput.classList.remove('error');
                    }
                }
                else {
                    groupSizeInput.classList.add('disabled');
                    groupSizeInput.querySelector('input').value = null;
                    groupSize = null;
                }

                if (option.dataset.billbylocation === 'Y' && option.dataset.billbyratio === 'N') {
                    serviceLocationDropdown.classList.remove('disabled');
                    if (!serviceLocation) {
                        serviceLocationDropdown.classList.add('error');
                    }
                    else {
                        serviceLocationDropdown.classList.remove('error');
                    }
                }
                else {
                    serviceLocationDropdown.classList.add('disabled');
                    serviceLocationDropdown.querySelector('select').value = '';
                    serviceLocation = null;
                }

                if (['A', 'C', 'D'].includes(option.dataset.fixedrate)) {
                    CDBDropdown.classList.remove('disabled');
                    if (!CDBCategory) {
                        CDBDropdown.classList.add('error');
                    }
                    else {
                        CDBDropdown.classList.remove('error');
                    }
                }
                else {
                    CDBDropdown.classList.add('disabled');
                    CDBDropdown.querySelector('select').value = '';
                    CDBCategory = null;
                }

                if (['A', 'D'].includes(option.dataset.fixedrate) && ['W', 'D'].includes(option.dataset.includeinfundinglimit)) {
                    assessmentDropdown.classList.remove('disabled');
                    if (option.dataset.includeinfundinglimit === 'D') {
                        const dropdownData = [{ key: 1, value: 'A' }, { key: 2, value: 'A1' }, { key: 3, value: 'B' }, { key: 4, value: 'C' }].map(item => ({
                            value: String(item.key),
                            text: item.value
                        }));
                        dropdownData.unshift(defaultOption);
                        dropdown.populate(assessmentDropdown, dropdownData, assessmentAcuityScore);
                    }
                    else if (option.dataset.includeinfundinglimit === 'W') {
                        const dropdownData = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => ({
                            text: String(num),
                            value: num
                        }));
                        dropdownData.unshift(defaultOption);
                        dropdown.populate(assessmentDropdown, dropdownData, assessmentAcuityScore);
                    }

                    if (!assessmentAcuityScore) {
                        assessmentDropdown.classList.add('error');
                    }
                    else {
                        assessmentDropdown.classList.remove('error');
                    }
                }
                else {
                    assessmentDropdown.classList.add('disabled');
                    assessmentDropdown.querySelector('select').value = '';
                    assessmentAcuityScore = null;
                }
            }
            else {
                resetFields();
            }
            validatePopupFields();
        }
    }

    return {
        init,
        buildNewVendorUCRForm,
        getMarkup,
        showUCRPopup
    };
})(); 